(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const isAllCollectionPath = /\/collections\/all\/?$/.test(url.pathname);
  if (isAllCollectionPath && !url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'price-descending');
    window.location.replace(url.toString());
  }
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zeya-product-accordion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initAccordions() {
      document.querySelectorAll('.zeya-accordion').forEach(function(accordion) {
        const tabs = Array.from(accordion.querySelectorAll('[role="tab"]'));
        const panels = tabs.map(function(tab) {
          return document.getElementById(tab.getAttribute('aria-controls'));
        });

        function select(index, moveFocus) {
          tabs.forEach(function(tab, i) {
            const active = i === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            panels[i].classList.toggle('is-active', active);
            panels[i].hidden = !active;
          });
          if (moveFocus) tabs[index].focus();
        }

        tabs.forEach(function(tab, i) {
          tab.addEventListener('click', function() {
            select(i, false);
          });

          tab.addEventListener('keydown', function(event) {
            const targets = {
              ArrowRight: (i + 1) % tabs.length,
              ArrowLeft: (i - 1 + tabs.length) % tabs.length,
              Home: 0,
              End: tabs.length - 1
            };
            const next = targets[event.key];
            if (next === undefined) return;
            event.preventDefault();
            select(next, true);
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccordions);
    } else {
      initAccordions();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zeya-product-ritual"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('.zeya-product-ritual');
    if (!section) return;

    const MOBILE_BREAKPOINT = 749;

    function getButton() {
      return section.querySelector('.product-details .add-to-cart-button');
    }

    function getPriceText() {
      const priceEl = section.querySelector('.product-details product-price .price');
      return priceEl ? priceEl.textContent.trim() : null;
    }

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function getComparePriceText() {
      const compareEl = section.querySelector('.product-details product-price .compare-at-price');
      return compareEl ? compareEl.textContent.trim() : null;
    }

    function updateButtonText() {
      const btn = getButton();
      if (!btn) return;
      const labelSpan = btn.querySelector('.zeya-btn-label');
      const compareSpan = btn.querySelector('.zeya-btn-compare-price');
      if (!labelSpan) return;

      if (!isMobile()) {
        if (btn.dataset.zeyaDefaultText) {
          labelSpan.textContent = btn.dataset.zeyaDefaultText;
        }
        if (compareSpan) compareSpan.textContent = '';
        return;
      }

      if (btn.disabled) return;

      const price = getPriceText();
      if (!price) return;

      const comparePrice = getComparePriceText();

      if (!btn.dataset.zeyaDefaultText) {
        btn.dataset.zeyaDefaultText = labelSpan.textContent.trim();
      }

      labelSpan.textContent = section.dataset.buyMobileLabel + ' ' + price;
      if (compareSpan) {
        compareSpan.textContent = comparePrice ? ' ' + comparePrice : '';
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateButtonText);
    } else {
      updateButtonText();
    }

    window.addEventListener('resize', () => requestAnimationFrame(updateButtonText));

    section.addEventListener('variant:update', () => {
      requestAnimationFrame(() => requestAnimationFrame(updateButtonText));
    });
  })();

  /* Zeya: affiche le score numérique à côté des étoiles Judge.me (ex. 4,8/5) */
  (function() {
    const section = document.querySelector('.zeya-product-ritual');
    if (!section) return;

    function decorateScore(badge) {
      if (badge.querySelector('.jdgm-prev-badge__score')) return;
      const rating = parseFloat(badge.dataset.averageRating);
      if (!isFinite(rating) || rating <= 0) return;
      const formatted = (Math.round(rating * 10) / 10).toString().replace('.', ',');
      const score = document.createElement('span');
      score.className = 'jdgm-prev-badge__score';
      score.textContent = formatted + '/5' + (badge.querySelector('.jdgm-prev-badge__text') ? ' ·' : '');
      const stars = badge.querySelector('.jdgm-prev-badge__stars');
      if (stars) stars.after(score);
    }

    function scanScores() {
      section.querySelectorAll('.jdgm-prev-badge').forEach(decorateScore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scanScores);
    } else {
      scanScores();
    }

    new MutationObserver(scanScores).observe(section, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zeya-reviews"] && !Shopify.designMode) return;
  try {
    
  const ZeyaReviews = {
    init() {
      this.el = document.querySelector('[data-testid="zeya-reviews"]');
      if (!this.el) return;
      this.loadingEl = this.el.querySelector('.zeya-reviews__loading');
      this.errorEl = this.el.querySelector('.zeya-reviews__error');
      this.emptyEl = this.el.querySelector('.zeya-reviews__empty');
      this.resultsEl = this.el.querySelector('.zeya-reviews__results');
      this.contentEl = this.el.querySelector('.zeya-reviews__content');
      this.load();
    },

    load() {
      this._show(this.loadingEl);
      const apiKey = this.el.dataset.apiKey;
      if (!apiKey) {
        this._showError(this.el.dataset.errorApiKey);
        return;
      }
      const cfg = {
        apiKey,
        shopDomain: this.el.dataset.shopDomain,
        template: this.el.dataset.template,
        trustTemplate: this.el.dataset.trustTemplate || '',
        productId: this.el.dataset.productId || null,
        filterByProduct: this.el.dataset.filterByProduct === 'true',
        starColor: getComputedStyle(this.el).getPropertyValue('--zeya-reviews-star').trim() || '#E8B4A5',
        cardBg: getComputedStyle(this.el).getPropertyValue('--zeya-reviews-card-bg').trim() || '#FFFFFF',
      };
      this.cfg = cfg;
      this._fetchData(cfg);
    },

    async _fetchData(cfg) {
      try {
        let jmProductId = null;
        if (cfg.productId && cfg.filterByProduct) {
          jmProductId = await this._getJudgeMeProductId(cfg.productId);
        }
        this.jmProductId = jmProductId;

        if (cfg.template === 'badge' || cfg.template === 'trust') {
          await this._loadCount(jmProductId);
        } else if (cfg.template === 'carousel') {
          await this._loadReviews({ per_page: 8 }, jmProductId);
        } else if (cfg.template === 'grid') {
          await this._loadReviews({ per_page: 12, page: 1 }, jmProductId);
        } else if (cfg.template === 'hero') {
          await this._loadReviews({ per_page: 1 }, jmProductId);
        }
      } catch (err) {
        console.error('ZeyaReviews error:', err);
        this._showError();
      }
    },

    async _api(endpoint, params = {}) {
      const url = new URL('https://judge.me/api/v1' + endpoint);
      url.searchParams.set('shop_domain', this.cfg.shopDomain);
      url.searchParams.set('api_token', this.cfg.apiKey);
      for (const [k, v] of Object.entries(params)) {
        if (v !== null && v !== undefined && v !== '') url.searchParams.set(k, v);
      }
      const res = await fetch(url);
      if (!res.ok) throw new Error('Judge.me API error: ' + res.status);
      return res.json();
    },

    async _getJudgeMeProductId(shopifyId) {
      if (!shopifyId) return null;
      const data = await this._api('/products/-1', { external_id: shopifyId });
      return data?.product?.id || null;
    },

    async _loadCount(jmProductId) {
      const params = jmProductId ? { product_id: jmProductId } : {};
      const data = await this._api('/reviews/count', params);
      if (!data.count || data.count === 0) {
        this._showEmpty(!!jmProductId);
        return;
      }
      const info = { count: data.count, rating: data.rating || 0 };
      const dyn = this.el.querySelector('[data-sub-dynamic]');
      if (dyn) {
        dyn.hidden = false;
        const decimalSep = (document.documentElement.lang || '').startsWith('en') ? '.' : ',';
        const avg = (Math.round(info.rating * 10) / 10).toString().replace('.', decimalSep);
        // placeholders %{count}/%{rating} dans la locale (pas des sorties Liquid)
        dyn.textContent = (this.cfg.trustTemplate || '').replace('%{count}', info.count).replace('%{rating}', avg);
      }
      if (this.cfg.template === 'badge') this._renderBadge(info);
      else this._renderTrust(info);
    },

    async _loadReviews({ page, per_page }, jmProductId) {
      const params = { page, per_page, sort: 'created_at' };
      if (jmProductId) params.product_id = jmProductId;
      const data = await this._api('/reviews', params);
      if (!data.reviews || data.reviews.length === 0) {
        this._showEmpty(!!jmProductId);
        return;
      }
      const totalPages = Math.ceil((data.total || 0) / per_page);
      if (this.cfg.template === 'carousel') this._renderCarousel(data.reviews);
      else if (this.cfg.template === 'grid') this._renderGrid(data.reviews, page < totalPages, page);
      else if (this.cfg.template === 'hero') this._renderHero(data.reviews);
    },

    _starsHtml(rating) {
      const full = Math.floor(rating);
      const partial = rating - full;
      const starsSuffix = this.el.dataset.starsSuffix || '';
      let html = '<span class="zeya-reviews__stars" role="img" aria-label="' + rating.toFixed(1) + ' ' + starsSuffix + '">';
      for (let i = 0; i < 5; i++) {
        if (i < full) {
          html += '<svg class="zeya-reviews__star zeya-reviews__star--full" viewBox="0 0 20 20" width="15" height="15"><path d="M10 0l2.45 7.55h7.93l-6.41 4.66 2.45 7.55L10 15.1l-6.42 4.66 2.45-7.55L-.38 7.55h7.93L10 0z" fill="currentColor"/></svg>';
        } else if (i === full && partial > 0) {
          const pct = Math.round(partial * 100);
          html += '<svg class="zeya-reviews__star zeya-reviews__star--partial" viewBox="0 0 20 20" width="15" height="15"><defs><clipPath id="zr-clip-' + i + '"><rect x="0" y="0" width="' + pct + '%" height="100%"/></clipPath></defs><path d="M10 0l2.45 7.55h7.93l-6.41 4.66 2.45 7.55L10 15.1l-6.42 4.66 2.45-7.55L-.38 7.55h7.93L10 0z" fill="currentColor" opacity="0.2"/><path d="M10 0l2.45 7.55h7.93l-6.41 4.66 2.45 7.55L10 15.1l-6.42 4.66 2.45-7.55L-.38 7.55h7.93L10 0z" fill="currentColor" clip-path="url(#zr-clip-' + i + ')"/></svg>';
        } else {
          html += '<svg class="zeya-reviews__star zeya-reviews__star--empty" viewBox="0 0 20 20" width="15" height="15"><path d="M10 0l2.45 7.55h7.93l-6.41 4.66 2.45 7.55L10 15.1l-6.42 4.66 2.45-7.55L-.38 7.55h7.93L10 0z" fill="currentColor" opacity="0.2"/></svg>';
        }
      }
      html += '</span>';
      return html;
    },

    _formatDate(dateStr) {
      if (!dateStr) return '';
      try {
        const locale = this.el.dataset.locale || 'fr';
        return new Date(dateStr).toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' });
      } catch { return ''; }
    },

    _escapeHtml(str) {
      if (!str) return '';
      const el = document.createElement('div');
      el.textContent = str;
      return el.innerHTML;
    },

    _cardHtml(review) {
      const name = this._escapeHtml(review.reviewer?.name || this.el.dataset.anonymousName || '');
      const title = this._escapeHtml(review.title || '');
      const body = this._escapeHtml(review.body || '');
      const date = this._formatDate(review.created_at);
      const prod = this._escapeHtml(review.product_title || '');
      const pics = review.pictures || [];
      return '<article class="zeya-reviews__card">'
        + this._starsHtml(review.rating)
        + (body ? '<div class="zeya-reviews__card-body"><p>' + body + '</p></div>' : '')
        + (pics.length ? '<div class="zeya-reviews__card-pics">' + pics.map(p => p.urls?.small ? '<img src="' + p.urls.small + '" alt="" loading="lazy" class="zeya-reviews__card-pic">' : '').join('') + '</div>' : '')
        + (prod ? '<p class="zeya-reviews__card-product">' + prod + '</p>' : '')
        + '<footer class="zeya-reviews__card-footer"><span class="zeya-reviews__card-name">' + name + '</span>'
        + (date ? '<time class="zeya-reviews__card-date" datetime="' + review.created_at + '">' + date + '</time>' : '')
        + '</footer>'
        + '</article>';
    },

    _renderBadge(info) {
      this._show(this.resultsEl);
      const verifiedSuffix = this.el.dataset.verifiedSuffix || '';
      this.resultsEl.innerHTML = '<div class="zeya-reviews__badge">'
        + this._starsHtml(info.rating)
        + '<div class="zeya-reviews__rating-row"><span class="zeya-reviews__rating-number">' + info.rating.toFixed(1) + '</span><span class="zeya-reviews__rating-max">/ 5</span></div>'
        + '<p class="zeya-reviews__count-text">' + info.count + ' ' + verifiedSuffix + '</p>'
        + '</div>';
    },

    _renderTrust(info) {
      this._show(this.resultsEl);
      const verifiedSuffix = this.el.dataset.verifiedSuffix || '';
      this.resultsEl.innerHTML = '<div class="zeya-reviews__trust">'
        + '<div class="zeya-reviews__trust-item"><span class="zeya-reviews__trust-number">' + info.rating.toFixed(1) + '</span>' + this._starsHtml(info.rating) + '</div>'
        + '<div class="zeya-reviews__trust-divider" aria-hidden="true"></div>'
        + '<div class="zeya-reviews__trust-item"><span class="zeya-reviews__trust-number">' + info.count + '</span><span class="zeya-reviews__trust-label">' + verifiedSuffix + '</span></div>'
        + '</div>';
    },

    _renderCarousel(reviews) {
      this._show(this.resultsEl);
      const cards = reviews.map(r => this._cardHtml(r)).join('');
      const prevLabel = this.el.dataset.carouselPrevLabel || '';
      const nextLabel = this.el.dataset.carouselNextLabel || '';
      this.resultsEl.innerHTML = '<div class="zeya-reviews__carousel">'
        + '<button type="button" class="zeya-reviews__carousel-btn zeya-reviews__carousel-btn--prev" aria-label="' + prevLabel + '"><svg width="15" height="15" viewBox="0 0 20 20"><path d="M12.5 3.75L6.25 10l6.25 6.25" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        + '<div class="zeya-reviews__carousel-track">' + cards + '</div>'
        + '<button type="button" class="zeya-reviews__carousel-btn zeya-reviews__carousel-btn--next" aria-label="' + nextLabel + '"><svg width="15" height="15" viewBox="0 0 20 20"><path d="M7.5 3.75L13.75 10l-6.25 6.25" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        + '</div>';
      this._initCarousel();
    },

    _initCarousel() {
      const track = this.resultsEl.querySelector('.zeya-reviews__carousel-track');
      if (!track) return;
      const prev = this.resultsEl.querySelector('.zeya-reviews__carousel-btn--prev');
      const next = this.resultsEl.querySelector('.zeya-reviews__carousel-btn--next');
      const scroll = (dir) => {
        const card = track.querySelector('.zeya-reviews__card');
        const gap = 24;
        const w = card ? card.offsetWidth + gap : 350;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', () => scroll(-1));
      if (next) next.addEventListener('click', () => scroll(1));
    },

    _renderGrid(reviews, hasMore, page) {
      this._show(this.resultsEl);
      const cards = reviews.map(r => this._cardHtml(r)).join('');
      const loadMoreLabel = this.el.dataset.loadMoreLabel || '';
      this.resultsEl.innerHTML = '<div class="zeya-reviews__grid" data-page="' + page + '">' + cards + '</div>'
        + (hasMore ? '<button type="button" class="zeya-reviews__load-more">' + loadMoreLabel + '</button>' : '');
      if (hasMore) this._initLoadMore(reviews, page);
    },

    _initLoadMore() {
      const btn = this.resultsEl.querySelector('.zeya-reviews__load-more');
      if (!btn) return;
      const loadMoreLabel = this.el.dataset.loadMoreLabel || '';
      const loadingLabel = this.el.dataset.loadingLabel || '';
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        btn.textContent = loadingLabel;
        try {
          const grid = this.resultsEl.querySelector('.zeya-reviews__grid');
          const page = parseInt(grid.dataset.page) + 1;
          const params = { page, per_page: 12, sort: 'created_at' };
          if (this.jmProductId) params.product_id = this.jmProductId;
          const data = await this._api('/reviews', params);
          if (data.reviews) {
            for (const r of data.reviews) {
              grid.insertAdjacentHTML('beforeend', this._cardHtml(r));
            }
            grid.dataset.page = page;
            const totalPages = Math.ceil((data.total || 0) / 12);
            if (page < totalPages) {
              btn.disabled = false;
              btn.textContent = loadMoreLabel;
            } else {
              btn.remove();
            }
          }
        } catch {
          btn.disabled = false;
          btn.textContent = loadMoreLabel;
        }
      });
    },

    _renderHero(reviews) {
      this._show(this.resultsEl);
      const r = reviews[0];
      if (!r) { this._showEmpty(!!this.jmProductId); return; }
      this.resultsEl.innerHTML = '<div class="zeya-reviews__hero">'
        + '<div class="zeya-reviews__hero-quote" aria-hidden="true"><svg width="48" height="40" viewBox="0 0 48 40" fill="none"><path d="M15.273 0C11.768 0 8.795 1.045 6.356 3.133C3.917 5.222 2.332 7.734 1.6 10.67C.868 13.516.5 15.918.5 17.877v21.09H20.59V17.877H10.227c0-2.846.626-5.182 1.878-7.008C13.356 9.044 15.05 7.66 17.182 6.7L15.273 0zm25.727 0c-3.505 0-6.478 1.045-8.918 3.133-2.44 2.089-4.024 4.601-4.755 7.538-.732 2.846-1.1 5.248-1.1 7.206v21.09H44.27V17.877H33.909c0-2.846.626-5.182 1.877-7.008 1.251-1.825 2.945-3.209 5.078-4.169L41 0z" fill="currentColor" opacity="0.12"/></svg></div>'
        + this._cardHtml(r)
        + '</div>';
    },

    _show(el) {
      [this.loadingEl, this.errorEl, this.emptyEl, this.resultsEl].forEach(e => {
        if (e) { e.hidden = true; e.setAttribute('aria-hidden', 'true'); }
      });
      if (el) { el.hidden = false; el.setAttribute('aria-hidden', 'false'); }
    },

    _showEmpty(filtered) {
      this._show(this.emptyEl);
      const msg = filtered
        ? (this.el.dataset.emptyFiltered || '')
        : (this.el.dataset.emptyAll || '');
      const p = this.emptyEl.querySelector('.zeya-reviews__empty-text');
      if (p) p.textContent = msg;
    },

    _showError(msg) {
      this._show(this.errorEl);
      const p = this.errorEl.querySelector('.zeya-reviews__error-text');
      if (p) p.textContent = msg || this.el.dataset.errorLoadDefault || '';
      const retry = this.errorEl.querySelector('.zeya-reviews__retry');
      if (retry) retry.addEventListener('click', () => this.load(), { once: true });
    },
  };

  document.addEventListener('DOMContentLoaded', () => ZeyaReviews.init());
  if (document.readyState === 'complete') ZeyaReviews.init();

  } catch(e) { console.error(e); }
})();
})();
